/**
 * orga-app-api - kommunikation-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MitteilungNotification { 
    absender?: string;
    betreff?: string;
    korrelation_id?: string;
    mitteilung_id?: string;
    titel?: string;
    text?: string;
    data?: { [key: string]: string; };
    notification_type?: string;
}

